import * as Yup from 'yup';
import { memo } from 'react';
import { compose } from 'redux';
import { withFormik } from 'formik';
//constants
import { FIELD_PASSWORD, FIELD_USERNAME, FIELD_TYPE_TEXT } from '../constants';
// utilities
import * as U from '../utilities';
// forms
import { Fieldset, FormFooter } from '../components/forms';
// ui
import { Flex } from '../ui';
//////////////////////////////////////////////////

export const validationSchemaLoginObject = {
  [FIELD_PASSWORD]: Yup.string()
    .nullable(true)
    .required(U.getRequiredLocaleTxt())
    .max(255, U.getShouldBeFromToCharLocaleTxt(0, 255)),
  [FIELD_USERNAME]: Yup.string()
    .nullable(true)
    .required(U.getRequiredLocaleTxt())
    .max(255, U.getShouldBeFromToCharLocaleTxt(0, 255)),
};

const initialValues = {
  [FIELD_USERNAME]: '',
  [FIELD_PASSWORD]: '',
};

const validationSchema = Yup.object().shape(validationSchemaLoginObject);

const commonStyles = {
  shrink: true,
  minWidth: 350,
  inputHeight: 6,
  marginBottom: '30px',
};

const submitBtnStyles = {
  width: 350,
};

const fieldSettings = [
  {
    required: true,
    label: 'labels.username',
    fieldName: FIELD_USERNAME,
    inputStyles: commonStyles,
    fieldType: FIELD_TYPE_TEXT,
  },
  {
    required: true,
    label: 'labels.password',
    fieldType: FIELD_PASSWORD,
    fieldName: FIELD_PASSWORD,
    inputStyles: commonStyles,
  },
];

const fieldsetStyles = {
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
};

const enhance = compose(
  withFormik({
    validationSchema,
    displayName: 'LOGIN_FORM',
    mapPropsToValues: () => initialValues,
    handleSubmit: (values, { props }) => {
      const { submitAction } = props;

      submitAction(values);
    },
  }),
  memo,
);

const LoginForm = enhance(props => (
  <form onSubmit={props.handleSubmit}>
    <Flex flexDirection='column'>
      <Fieldset
        {...U.getFormikProps(props)}
        fields={fieldSettings}
        fieldsetStyles={fieldsetStyles}
      />
      <FormFooter
        title={props.submitText}
        submitBtnStyles={submitBtnStyles}
        isSubmitting={props.isSubmitting}
      />
    </Flex>
  </form>
));

export default LoginForm;
